<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('dictionary.service')"
    icon="res-strategy"
    :res-name="listData.name"
    :actions="params.actions"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="params?.cloudEnv === 'service' ? singleActions : []" :row="listRowData" button-type="link" button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :res-id="listData.id"
      :id="listId"
      :data="listData"
      :cloud-env="params.cloudEnv"
      :on-manager="onManager"
      :getParams="getParams"
      :taskResource="taskResource"
      ignoreResId
      @side-page-trigger-handle="sidePageTriggerHandle"
      @init-side-page-tab="initSidePageTab"
      @single-refresh="singleRefresh" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import { supportTabs } from '../constants'
import Detail from './Detail'
import Worker from './Worker'
import Api from './Api'
import Db from './Db'
import Monitor from './Monitor'
export default {
  name: 'ServiceSidePage',
  components: {
    Actions,
    Detail,
    Worker,
    Api,
    Db,
    Monitor,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      configAfterConfigSave: null,
      rawDetailTabs: [
        { label: this.$t('common_428'), key: 'detail' },
        { label: this.$t('compute.text_608'), key: 'monitor' },
        { label: this.$t('system.worker_stats'), key: 'worker' },
        { label: this.$t('system.db_stats'), key: 'db' },
        { label: this.$t('system.api_stats'), key: 'api' },
        { label: this.$t('table.title.task'), key: 'task-drawer' },
      ],
    }
  },
  computed: {
    detailTabs () {
      if (this.params?.cloudEnv === 'baremetalagent') {
        return this.rawDetailTabs.filter(tab => tab.key === 'detail')
      }
      const serviceName = this.params?.cloudEnv === 'host' ? 'custom-host-list' : this.listRowData?.name
      const conf = supportTabs.find(item => item.name === serviceName)
      if (!conf) return this.rawDetailTabs
      const key2flag = {
        monitor: 'monitor',
        worker: 'worker',
        db: 'db',
        api: 'api',
        'task-drawer': 'task',
      }
      return this.rawDetailTabs.filter(tab => {
        if (tab.key === 'detail') return true
        if (tab.key === 'task-drawer' && !this.taskResource) return false
        const f = key2flag[tab.key]
        if (!f) return true
        return !!conf[f]
      })
    },
    getParams () {
      return null
    },
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'event-drawer':
          return 'EventListForStrategyAllocationSidePage'
        default:
          return ''
      }
    },
    listData () {
      return {
        ...this.listRowData,
        config: this.configAfterConfigSave ?? this.data?.data?.config,
      }
    },
    taskResource () {
      const raw = this.listData?.type || this.listData?.name
      if (!raw || typeof raw !== 'string') return ''
      return `${raw.replace('_v2', '')}-tasks`
    },
  },
  created () {
    this.$bus.$on('refresh-detail', this.refreshConfigAfterSave)
  },
  beforeDestroy () {
    this.$bus.$off('refresh-detail', this.refreshConfigAfterSave)
  },
  methods: {
    parseServiceConfig (res) {
      const body = res && res.data != null ? res.data : res
      const arr = body && body.data
      if (Array.isArray(arr) && arr[0] && arr[0].config) {
        return arr[0].config
      }
      if (body && body.config) {
        return body.config
      }
      return null
    },
    async refreshConfigAfterSave () {
      const id = this.listRowData?.id
      if (!id) return
      try {
        const res = await new this.$Manager(`services/${id}/config`, 'v1').list()
        this.configAfterConfigSave = this.parseServiceConfig(res)
      } catch (e) {
        this.configAfterConfigSave = null
      }
    },
  },
}
</script>
